import { gql } from '@apollo/client';

export const GET_REVIEWERS_DATA = gql`
  query QueryReviewers {
    appSpecialists: reviewers(role: APPLICATION_SPECIALIST) {
      edges {
        node {
          identifier
          fullNameShort
          user {
            identifier
            firstName
            lastName
            roles
          }
        }
      }
    }
    underwriters: reviewers(role: UNDERWRITER) {
      edges {
        node {
          identifier
          fullNameShort
          user {
            identifier
            firstName
            lastName
            roles
          }
        }
      }
    }
  }
`; 